import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Config from '../config/config';
import { detectIE } from '../utilites/util';
import { getCookie } from '../utilites/cookies';
import { X_MOCK_API, BFF_COOKIE_HEADER, YETTEL_ACCOUNT_COOKIE, SEC_FETCH_MODE } from '../constants/CookieConstants';
import store from '../app/store'; // Your Redux store

class HttpRequest {

  public static async request<T = any>(options: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    if (!options.url) {
      throw new Error('url is required');
    }

    options.baseURL = Config.api.baseUrl;
    options.method = options.method ?? 'get';
    options.headers = options.headers ?? {};

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      options.headers[SEC_FETCH_MODE] = 'no-cors';
    }
    const cookieToken = getCookie(YETTEL_ACCOUNT_COOKIE);

    if (cookieToken) {
      options.headers[BFF_COOKIE_HEADER] = cookieToken;
    }
    const state = store.getState();

    if (state.debug.data.mockResponse) {
      options.headers[X_MOCK_API] = true;
    }

    if (options.method === 'post' || options.method === 'put') {
      options.headers['Content-Type'] = 'application/json';
    }

    options.withCredentials = true;

    if (detectIE() && options.method === 'get') {
      options.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      options.headers.Pragma = 'no-cache';
      options.headers.Expires = '0';
    }
    try {
      const response: AxiosResponse = await axios(options);
      return response.data;
    } catch (error: any) {
      let err = {
        message: 'Server unavailable!',
        status: 500,
        meta: {},
      };

      const response = error.response;

      if (response?.data) {
        err = response.data;
      }

      throw err;
    }
  }

}

export default HttpRequest;
